import { registerLocale, getNames, getAlpha2Codes } from "i18n-iso-countries";
import enCountries from "i18n-iso-countries/langs/en.json";
import deCountries from "i18n-iso-countries/langs/de.json";
import environment from "@/environment";

// Register the locales so they are usable between languages.
registerLocale(enCountries);
registerLocale(deCountries);

export function getCountries(lang: string): { alpha2: string; name: string }[] {
  const names = getNames(lang);

  return Object.keys(names).map((key) => ({
    alpha2: key,
    name: names[key],
  }));
}

export function getCountryNames(lang: string): (string | string[])[] {
  const countriesJson = getNames(lang);

  return Object.keys(countriesJson).map((key) => {
    return countriesJson[key];
  });
}

export function getAlpha2CodesArray() {
  return Object.keys(getAlpha2Codes());
}

export function getHostnameForCountryCode(alpha2: string) {
  switch (alpha2) {
    // http://www.geocountries.com/country/codes/australia-and-oceania
    case "AS":
    case "AU":
    case "CX":
    case "CK":
    case "FJ":
    case "PF":
    case "GU":
    case "KI":
    case "MH":
    case "FM":
    case "NR":
    case "NC":
    case "NZ":
    case "NU":
    case "NF":
    case "MP":
    case "PW":
    case "PG":
    case "PN":
    case "WS":
    case "SB":
    case "TL":
    case "TK":
    case "TO":
    case "TV":
    case "VU":
    case "WF":
      return environment.brewmanAustralianLandingUrl;

    default:
      return environment.brewmanBelgianLandingUrl;
  }
}
